import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TokenService {
  private COOKIE_ACCEPTANCE = 'COOKIE_ACCEPTED';
  private AUTH_TOKEN = 'auth_token';
  private PROFILE_INFO = 'profile_info';
  private IS_ON_BOARDED = 'is_on_boarded'


  constructor() { }

  isCookieAccepted() {
    return localStorage.getItem(this.COOKIE_ACCEPTANCE) === '1';
  }

  get storage() {
    return this.isPersistentSession() ? localStorage : sessionStorage;
  }

  setCookieAcceptanceStatus() {
    localStorage.setItem(this.COOKIE_ACCEPTANCE, '1');
  }

  isPersistentSession() {
    return localStorage.getItem('rememberMe') === 'true'
  }


  setLoginData({ accessToken, ...data }: any) {
    this.storage.setItem(this.AUTH_TOKEN, accessToken);
    this.storage.setItem(this.PROFILE_INFO, JSON.stringify(data));
    const profileInfo = JSON.parse(this.storage.getItem(this.PROFILE_INFO) as string);
    const isOnboarded = profileInfo.businessProfile.isOnboarded
    this.setIsOnBoarded(isOnboarded)
  }

  // set the onboard value
  setIsOnBoarded(isOnboarded = false): void {
    this.storage.setItem(this.IS_ON_BOARDED, Number(isOnboarded).toString());
  }

  getIsOnBoarded(): boolean {
    return this.storage.getItem(this.IS_ON_BOARDED) === '1';
  }

  logout() {
    const isCookieAccepted = this.isCookieAccepted();
    localStorage.clear();
    sessionStorage.clear();
    if (isCookieAccepted) {
      this.setCookieAcceptanceStatus();
    }
  }

  getAccessToken(): any {
    return this.storage.getItem(this.AUTH_TOKEN);
  }

  getProfileInfo(): any {
    return JSON.parse(this.storage.getItem(this.PROFILE_INFO) as string);
  }

  getBusinessId(): any {
    try {
      const data = JSON.parse(this.storage.getItem(this.PROFILE_INFO) as string);
      return data?.businessProfile?.id || '';
    } catch (error) {
      console.error(error);
      return '';
    }
  }

  getStores() {
    try {
      const data = JSON.parse(this.storage.getItem(this.PROFILE_INFO) as string);
      return data?.stores || [];
    } catch (error) {
      console.error(error);
      return [];
    }
  }

  isLoggedIn(): boolean {
    return Boolean(this.storage.getItem(this.AUTH_TOKEN));
  }
}
